import { Component, inject, input, ViewChild } from '@angular/core';
import { ButtonComponent } from '../../../../kit/button/button.component';
import { FileUpload, FileUploadModule } from '@openng/optimus-ui/fileupload';
import { TranslatePipe } from '@ngx-translate/core';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { Validators } from '@angular/forms';
import { DefaultCategoryTypeEnum } from '@libs/types/src/file-manager/types/default-category.type';
import { ExternalType } from '@libs/types/src/file-manager/enum/external-type.enum';
import { ServiceCertificateTypeEnum } from '@libs/types/src/services/enum/service-certificate-type.enum';
import { ServiceUploadCertificateStore } from './service-upload-certificate.store';
import { PasswordInputComponent } from '../../../../kit/input/password-input/password-input.component';
import { uploadFile } from '../../../../../utils/files.utils';

@Component({
    selector: 'app-service-upload-certificate',
    imports: [ButtonComponent, FileUploadModule, TranslatePipe, PasswordInputComponent],
    templateUrl: './service-upload-certificate.component.html',
    styleUrl: './service-upload-certificate.component.scss',
    providers: [ServiceUploadCertificateStore],
})
export class ServiceUploadCertificateComponent {
    public readonly store = inject(ServiceUploadCertificateStore);
    @ViewChild('fu') fileUpload!: FileUpload;
    public serviceId = input<number>(0);

    protected form = fb.group({
        passphrase: fb.control<string | null>(null, Validators.required),
    });

    async save() {
        if (this.form.valid && this.fileUpload.files?.length && this.serviceId()) {

            const file = this.fileUpload.files[0];
            const uploadFileObj = await this.store.api.getPresignedUrl({
                name: file.name,
                categoryCode: DefaultCategoryTypeEnum.CERTIFICATES,
                owner: 'service_sukl_' + this.serviceId(),
                replace: false,
                note: null,
                kind: null,
                date: new Date(),
                accesses: [{
                    externalType: ExternalType.service,
                    externalId: this.serviceId().toString(),
                }],
            });

            await uploadFile({
                url: uploadFileObj.url,
                file: file,
            });

            const result = await this.store.api.confirmFileUpload({ id: uploadFileObj.id });

            await this.store.api.createServiceCertificate({
                type: ServiceCertificateTypeEnum.SUKL,
                key: this.form.value.passphrase!,
                cert: result.path,
                serviceId: this.serviceId(),
            });

            return true;
        } else {
            return false;
        }
    }
}
